import styles from './index.module.scss';
import defaultBg from './images/defaultBg.png';

const BannerBg = () => {
  return (
    <div className={styles.bannerBg}>
      <img src={defaultBg} />
    </div>
  );
};

export default BannerBg;
